module.exports = __webpack_public_path__ + "static/media/orbit-filter.434b3f31.jpeg";